export const toggleDrawer = (selectedIdx: number, toggleDirection: string, filterDrawers: any) => {
  //* For drawer of secondary filters
  if (filterDrawers?.current) {
    let topicTitle: string
    let el: any
    let idx = 0
    let selectedTopic = ''

    for ([topicTitle, el] of Object.entries(filterDrawers.current)) {
      if (idx === selectedIdx) {
        selectedTopic = topicTitle
      }
      if (filterDrawers?.current[topicTitle]?.classList.contains('Secondary-Drawer__Active')) {
        filterDrawers.current[topicTitle].classList.remove('Secondary-Drawer__Active')
      }
      idx++
    }

    if (toggleDirection === 'open') {
      //* Close any open drawers before opening another!
      filterDrawers?.current[selectedTopic]?.classList.add('Secondary-Drawer__Active')
    }
  }
}
